import { render, staticRenderFns } from "./Massive.vue?vue&type=template&id=3f888160"
import script from "./Massive.vue?vue&type=script&lang=js"
export * from "./Massive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports